import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.urlAlias';

const translations = {
    'urlAlias': 'Átirányítások',
    'edit.title': 'Átirányítás szerkesztése',
    'create.title': 'Új átirányítás',
    'urlAliasCreate': 'Új átirányítás',
    'id.title': 'ID',
    'source_url.title': 'Honnan',
    'target_url.title': 'Hová',
    'created_at.title': 'Létrehozva',
    'updated_at.title': 'Frissítve',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/UrlAlias/lang/hu.ts